import React, { useEffect, useState } from 'react';
import liracrypt from '../components/Liracrypt/liracrypt';
import { useSelector } from 'react-redux';

const ECNs = ({selectedLid}) => {
    const [ecnData, setEcnData] = useState([]);
    const urlCode = useSelector(state => state.urlCode)
    useEffect(() => {
        liracrypt.get("/livo/ecn", { dn: "xxx", lid: selectedLid })
            .then(response => {
                setEcnData(response.data.data);
            }).catch(err => {
                console.log(err);
            })
    }, []);

    return (
        <div className="ecn" style={{ display: 'flex', justifyContent: "space-around" }}>
            {ecnData.map((ecn, index) => (
                <a href={`v02/${urlCode}` + ecn.href} target="_blank" className="ecn-card" key={index} style={{ backgroundColor: ecn.backgroundColor || "#808080", padding: 10, display: 'flex', flexDirection: 'column' }}>
                    <span class="ecns_wrap" style={{ color: ecn.data1.fontColor }}>{ecn.data1.label}</span>
                    <span class="date_wrap" style={{ color: ecn.data2.fontColor }}>{ecn.data2.label}</span>
                    <span class="month_wrap" style={{ color: ecn.data3.fontColor }}>{ecn.data3.label}</span>
                    <span class="serial_wrap" style={{ color: ecn.data4.fontColor }}>{ecn.data4.label}</span>
                </a>
            ))}
        </div>
    );
};

export default ECNs;